import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-enach-working-flow-popup",
    templateUrl: "./enach-working-flow-popup.component.html",
    styleUrls: ["./enach-working-flow-popup.component.scss"],
    standalone: false
})
export class EnachWorkingFlowPopupComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<EnachWorkingFlowPopupComponent>
  ) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }
}
